import { colors } from "../../styles/theme";

// Pure vector mark (ring "C") — no font dependency, so it renders identically
// in-app and as an exported asset. Source of truth also lives at
// public/logo.svg and public/brand/ for standalone use (favicons, social avatars).
export default function Logo({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true" style={{ display: "block", flexShrink: 0 }}>
      <rect width="120" height="120" rx="26" fill={colors.ink} />
      <circle
        cx="60" cy="60" r="34" fill="none" stroke={colors.cream} strokeWidth="13"
        strokeLinecap="round" strokeDasharray="162.3 51.3" strokeDashoffset="-25.6"
      />
    </svg>
  );
}
